export default __webpack_public_path__ + "static/media/70.2518e3d9.gif";